<template>
  <div>
    <div class="bg-creme-50">
      <HiwTopSection />
      <HiwTimeline />
    </div>
    <div class="bg-creme-200">
      <HiwBottomSection />
    </div>
  </div>
</template>
<script>
import { HiwTopSection, HiwTimeline, HiwBottomSection } from "@/components/hiw";
export default {
  name: "HowItWorks",
  components: {
    HiwTopSection,
    HiwTimeline,
    HiwBottomSection,
  },
};
</script>
